import { styled, Typography } from '@mui/material'
import { Box } from '@mui/system'
import React from 'react'
import { Fade } from 'react-reveal'

const Wrapper=styled(Box)`
    margin-top:78px;
    background:#f6f6f6;
    padding-left: 47px;
    padding-top: 49px;
    padding-bottom: 60px;
`

const Education = () => {
  return (
    <Wrapper>
      <Fade left big>
      <h1 style={{color:'#010B30'}}>Education :</h1>
      <Box>
        <h1 style={{fontFamily:"'Lora', serif"}}>DIPLOMA IN COMPUTER ENGINEERING</h1>    
        <Typography>DSEU Shakarpur Campus - 1 (Formely Known as Ambedkar Institute of Techology)</Typography>
        <span style={{fontWeight:'600',fontFamily:"'Lora', serif"}}>2021-2023</span>
        <h1 style={{fontFamily:"'Lora', serif"}}>HIGH SCHOOL, CENTRAL BOARD OF SECONDARY EDUCATION</h1>
        <Typography>Scored 86.4% in PCM (Non-Medical) with Computer Science</Typography>
        <span style={{fontWeight:'600',fontFamily:"'Lora', serif"}}>2020-2021</span>
        <h1 style={{fontFamily:"'Lora', serif"}}>SECONDARY SCHOOL, CENTRAL BOARD OF SECONDARY EDUCATION</h1>
        <Typography>Scored 88.6% </Typography>
        <span style={{fontWeight:'600',fontFamily:"'Lora', serif"}}>2018-2019</span>
      </Box>
      </Fade>
    </Wrapper>
  )
}

export default Education
